export enum TransactionTypeModes {
  Actual = 1,
  Hypothetical = 2,
  Test = 3,
  Valuation = 4,
  Deleted = 5,
  Internal = 6,
  Component = 7,
  TradeRequest = 8,
}
